package music.jammers.client.shared.profile.presentation.ui

import music.jammers.client.shared.event.domain.model.ValidationError
import music.jammers.client.shared.event.domain.model.ValidationErrorValue
import music.jammers.client.shared.profile.domain.ValidateProfileUseCase

class ProfileFieldValidator {

    fun validate(name: String, value: String): ValidationError? =
        when (name) {
            ValidateProfileUseCase.NAME -> {
                validateString(name, value, TEXT_LENGTH_LIMIT, allowedNameSymbolsRegex)
            }

            ValidateProfileUseCase.TELEGRAM -> {
                when {
                    value == "@" -> {
                        ValidationError(name, ValidationErrorValue.EmptyValue)
                    }

                    value.startsWith("@") -> {
                        validateString(name, value, TEXT_LENGTH_LIMIT, allowedTelegramSymbolsRegex)
                    }

                    else -> {
                        ValidationError(name, ValidationErrorValue.MustStartWith("@"))
                    }
                }
            }

            ValidateProfileUseCase.CITY -> {
                validateString(name, value, TEXT_LENGTH_LIMIT, allowedNameSymbolsRegex)
            }

            else -> null
        }

    private fun validateString(
        name: String,
        value: String,
        maxLength: Int,
        allowedSymbolRegex: Regex,
    ): ValidationError? = when {
        value.isEmpty() -> {
            ValidationError(name, ValidationErrorValue.EmptyValue)
        }

        !allowedSymbolRegex.matches(value) -> {
            ValidationError(name, ValidationErrorValue.InvalidSymbol)
        }

        value.length > maxLength -> {
            ValidationError(name, ValidationErrorValue.StringMaxLength(maxLength, value.length))
        }

        else -> {
            null
        }
    }

    private companion object {

        val allowedNameSymbolsRegex = """[A-zА-я0-9." -]+${'$'}""".toRegex()
        val allowedTelegramSymbolsRegex = """[A-zА-я0-9."@ -]+${'$'}""".toRegex()
        const val TEXT_LENGTH_LIMIT = 35
    }
}